import { render, staticRenderFns } from "./MonthSwitcher.vue?vue&type=template&id=9b90a74c&lang=pug&"
import script from "./MonthSwitcher.vue?vue&type=script&lang=ts&"
export * from "./MonthSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./MonthSwitcher.vue?vue&type=style&index=0&id=9b90a74c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports